import { PushService } from './services/push.service';
import {Component} from '@angular/core';
import {App} from '@capacitor/app';
import {Capacitor} from "@capacitor/core";
import { StatusBar, Style } from '@capacitor/status-bar';
import {StorageService} from "./services/storage.service";
import {UserService} from "./services/user.service";
// import { FirebaseMessaging } from '@capacitor-firebase/messaging';
import {CacheKeys} from "./structure/enums/cache-keys.class";
import {Router} from "@angular/router";
import {AlertController} from "@ionic/angular/lazy";
import {AnalyticsService} from "./services/analytics.service";
import {LangService} from "./services/lang.service";

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    standalone: false
})

export class AppComponent {
    constructor(
        private storageService: StorageService,
        private userService: UserService,
        private router: Router,
        private pushService: PushService,
        private analytics: AnalyticsService,
        private alertController: AlertController,
        private lang: LangService,
    ) {
    }

    async close() {

        const platform = Capacitor.getPlatform();

        switch (platform) {
            case "ios":
                break;

            case "android":
                await App.exitApp();
                break;
            //Web Version
            default:
                close();

        }
        if (Capacitor.getPlatform() === 'ios') {
            // do something
        }

    }

    // private async syncPushPermissionWithBackend() {
    //     if (Capacitor.getPlatform() === 'web') return;
    //     if (!this.userService.isLoggedIn) return;
    //
    //     try {
            // const permission = await FirebaseMessaging.checkPermissions();
            // const granted = permission.receive === 'granted';

            // const account = await this.userService.getAccount(true);

            // if (!account?.email) {
            //     return;
            // }

            // const currentPush = !!account.pushNotificationsEnabled;
            // const currentLive = !!account.liveIncidentsEnabled;

            // if (currentPush === granted) {
            //     return;
            // }

            // await this.userService.updateNotificationSettings({
            //     push_notifications_enabled: granted,
            //     live_incidents_enabled: granted ? currentLive : false,
            // });

    //         await this.userService.getAccount(true);
    //     } catch (e) {
    //         console.error('Failed to sync push permission with backend', e);
    //     }
    // }

    // private async handlePushNavigationFromData(data: any) {
    //     if (!data) return;
    //
    //     const payload = data?.notification?.data ?? data?.data ?? data;
    //
    //     const type = payload?.type ?? null;
    //     const liveIncidentId = payload?.live_incident_id ?? null;
    //
    //     if (type === 'live_incident' && liveIncidentId) {
    //         await this.router.navigate(['/live-incident', liveIncidentId]);
    //     }
    // }

    // private async initPush() {
    //     if (Capacitor.getPlatform() === 'web') return;
    //     try {
    //         // iOS: ask permission (Android usually auto-granted depending on version)
    //         const perm = await FirebaseMessaging.requestPermissions();
    //         console.log('FCM permission:', perm);
    //
    //         const { token } = await FirebaseMessaging.getToken();
    //         console.log('✅ FCM Token:', token);
    //
    //         await this.storageService.set(CacheKeys.FCM_CODE, token);
    //
    //         setTimeout(async () => {
    //             const stored = await this.storageService.get(CacheKeys.FCM_CODE);
    //             console.log('✅ Stored token:', stored);
    //         }, 1000);
    //
    //         // Token refresh
    //         FirebaseMessaging.addListener('tokenReceived', async (event) => {
    //             console.log('🔄 FCM token refreshed:', event.token);
    //             await this.storageService.set(CacheKeys.FCM_CODE, event.token);
    //         });
    //
    //         // Foreground notifications
    //         FirebaseMessaging.addListener('notificationReceived', (event) => {
    //             console.log('📩 Notification received:', event);
    //         });
    //
    //         // Tap action
    //         FirebaseMessaging.addListener('notificationActionPerformed', async (event) => {
    //             console.log('👉 Notification clicked:', event);
    //
    //             await this.handlePushNavigationFromData(event);
    //         });
    //     } catch (e) {
    //         console.error('FCM init error:', e);
    //     }
    // }


    async ngOnInit() {
        await this.userService.init();

        // Already said yes on this phone? Then make sure the server still has
        // its token: phones replace tokens without anyone signing in again.
        this.pushService.refreshRegistration().catch(() => {});

        await this.analytics.init();
        if (this.analytics.needsChoice()) {
            this.askAboutStatistics();
        }
        // await this.initPush();
        // await this.syncPushPermissionWithBackend();

        try {
            if (Capacitor.getPlatform() === 'ios') {
                // iOS: set status bar appearance explicitly
                await StatusBar.setOverlaysWebView({ overlay: false });
                await StatusBar.setBackgroundColor({ color: '#000000' });
            }
            // setStyle uses WindowInsetsControllerCompat on Android — safe on all versions
            await StatusBar.setStyle({ style: Style.Dark });
            await StatusBar.show();
        } catch (err) {
            console.warn('StatusBar plugin not available:', err);
        }
    }

    /**
     * Asked once, on first open of the store apps, before anything is
     * collected. Both answers are equally easy, the question cannot be
     * dismissed without one, and Account lets the person change it later.
     */
    private async askAboutStatistics(): Promise<void> {
        const t = (key: string, fallback: string) => this.lang.data[key] || fallback;
        const alert = await this.alertController.create({
            header: t('analytics.consent_title', 'Help us improve the app'),
            message: t('analytics.consent_message', 'Can we collect statistics about how the app is used, such as which screens are opened? It helps us make the app better. We do not use it for advertising and we never see what you write. You can change this at any time in Account.'),
            backdropDismiss: false,
            cssClass: 'analytics-consent',
            buttons: [
                {
                    text: t('analytics.consent_decline', 'No thanks'),
                    handler: () => { this.analytics.setConsent(false); },
                },
                {
                    text: t('analytics.consent_allow', 'Allow'),
                    handler: () => { this.analytics.setConsent(true); },
                },
            ],
        });
        await alert.present();
    }
}
